class ExpiringStorage {
    get(key) {
        const cached = JSON.parse(localStorage.getItem(key));
        let returnValue;
        if (cached) {
            const expires = new Date(cached.expires);
            if (expires < new Date()) {
                localStorage.removeItem(key);
                returnValue = null;
            } else {
                returnValue = cached.value;
            }
        } else {
            returnValue = null;
        }
        return returnValue;
    }

    set(key, value, lifeInMinutes) {
        const currentTime = new Date().getTime();
        const expires = new Date(currentTime + lifeInMinutes * 60000);
        localStorage.setItem(key, JSON.stringify({value, expires}));
    }
}

export default new ExpiringStorage();



// WEBPACK FOOTER //
// ./resources/components/vendor/expiring-storage.js